import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { CheckContextProvider } from './context/Checka';
import { ThemeContextProvider } from './context/Theme';
import { useCookies } from 'react-cookie';
import StroCarga from './pages/StroCarga';
import StroChoque from './pages/StroChoque';
import Login from './pages/Login';
import TablaCarga from './pages/CargaTabla';
import StroContractuales from './pages/StroContractuales';
import Ampliaciones from './pages/Ampliaciones';
import TablaValoresContractuales from './pages/TablaValoresContractuales';
import TablaSolicitudes from './pages/TablaSolicitudes';
import Reclamo from './pages/Reclamo';
import NuevaTabla from './pages/NuevaTabla';
import NuevoStroCargas from './pages/NuevoStroCargas';
import NuevoStro from './pages/NuevoStro';
import { useContext, useEffect } from 'react';
import TablaSolicitudesPrueba from './pages/TablaSolicitudesPrueba';
import Ajustes from './pages/Ajustes';
import Estadisticas from './pages/Estadisticas';
import CargarReclamo from './pages/CargarReclamo';
import Tabla2026Cargas from './pages/Tabla2026Cargas';
import Dashboard from './pages/Dashboard';
import DashboardReclamosPage from './pages/DashboardReclamosPage';
import Capturas from './pages/Capturas';
function AppWrapper() {
  return (
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  );
}
function App() {
  const [cookies] = useCookies(['user']);
  return (
    <HashRouter>
      <CheckContextProvider>
        <Routes>
          <Route exact path='/' element={cookies.user ? <NuevaTabla /> : <Login />} />
          <Route exact path='/login' element={<Login />} />

          <Route exact path='/estadisticas' element={cookies.user ? <Estadisticas /> : <Login />} />
          <Route exact path='/valoresContractuales' element={cookies.user ? <TablaValoresContractuales /> : <Login />} />
          <Route exact path='/ampliaciones' element={cookies.user ? <Ampliaciones /> : <Login />} />
          <Route exact path='/solicitudes' element={cookies.user ? <TablaSolicitudes /> : <Login />} />
          <Route exact path='/reclamos' element={cookies.user ? <DashboardReclamosPage /> : <Login />} />
          <Route exact path='/solicitudesPruebas' element={cookies.user ? <TablaSolicitudesPrueba /> : <Login />} />
          <Route exact path='/reclamo/:idReclamo' element={<Reclamo />} />
          <Route exact path='/tabla' element={cookies.user ? <NuevaTabla /> : <Login />} />
          <Route
            exact
            path='/nuevoStro/:id'
            element={cookies?.user?.depto === 'cargas' ? <NuevoStroCargas /> : cookies?.user?.depto === 'choques' ? <NuevoStro /> : cookies?.user?.depto === 'contractuales' ? <NuevoStro /> : null}
          />
          <Route exact path='/tablaVieja' element={cookies.user ? <TablaCarga /> : <Login />} />
          <Route
            exact
            path='/viejoStro/:id'
            element={cookies?.user?.depto === 'cargas' ? <StroCarga /> : cookies?.user?.depto === 'choques' ? <StroChoque /> : cookies?.user?.depto === 'contractuales' ? <StroContractuales /> : null}
          />
          <Route exact path='/ajustes' element={cookies?.user?.area === 'Administracion' ? <Ajustes /> : <Login />} />
          <Route exact path='/cargarReclamo' element={<CargarReclamo />} />
          <Route exact path='/tabla2026' element={<Tabla2026Cargas />} />
          <Route exact path='/dashboard' element={cookies.user ? <Dashboard /> : <Login />} />
          <Route exact path='/capturas' element={cookies?.user?.titulo === 'admin' ? <Capturas /> : <Login />} />
          <Route
            exact
            path='/:id'
            element={cookies?.user?.depto === 'cargas' ? <NuevoStroCargas /> : cookies?.user?.depto === 'choques' ? <NuevoStro /> : cookies?.user?.depto === 'contractuales' ? <NuevoStro /> : null}
          />
        </Routes>
      </CheckContextProvider>
    </HashRouter>
  );
}

export default AppWrapper;
